import { render, staticRenderFns } from "./AverageBySubjects.vue?vue&type=template&id=7905330d"
import script from "./AverageBySubjects.vue?vue&type=script&lang=js"
export * from "./AverageBySubjects.vue?vue&type=script&lang=js"
import style0 from "./AverageBySubjects.vue?vue&type=style&index=0&id=7905330d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports